import { Controller } from "@hotwired/stimulus"

// Overlay drawer behavior for the team-member detail: locks page scroll
// while open and closes (navigates back to the list) on Escape.
export default class extends Controller {
  static values = { closeUrl: String }

  connect() {
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"

    this.onKeydown = (e) => {
      if (e.key !== "Escape" || !this.hasCloseUrlValue) return
      // The Edit modal opens on top of the drawer as a static modal (Escape is
      // disabled there on purpose). Closing the drawer under it would navigate
      // away mid-edit, so the drawer ignores Escape while a modal is open.
      if (document.querySelector(".modal.show")) return

      window.Turbo ? window.Turbo.visit(this.closeUrlValue) : (window.location.href = this.closeUrlValue)
    }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.body.style.overflow = this.previousOverflow
    document.removeEventListener("keydown", this.onKeydown)
  }
}
